import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { APP_CONFIG } from '../config/app';
import MainLayout from '../layouts/MainLayout';
import HomePage from '../pages/HomePage';
import DepannageInformatique from '../pages/DepannageInformatique';
import CreationSiteWeb from '../pages/CreationSiteWeb';
import UserDashboard from '../pages/UserDashboard';
import TicketDetail from '../pages/TicketDetail';
import ExpertsMap from '../pages/ExpertsMap';
import PrivateRoute from './PrivateRoute';
import PolitiqueConfidentialite from '../pages/legal/PolitiqueConfidentialite';
import MentionsLegales from '../pages/legal/MentionsLegales';
import ConditionsUtilisation from '../pages/legal/ConditionsUtilisation';
import VerifyEmail from '../pages/VerifyEmail';

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout><Outlet /></MainLayout>}>
        <Route path={APP_CONFIG.routes.home} element={<HomePage />} />
        <Route path={APP_CONFIG.routes.depannage} element={<DepannageInformatique />} />
        <Route path={APP_CONFIG.routes.creationSite} element={<CreationSiteWeb />} />
        <Route path={APP_CONFIG.routes.expertsMap} element={<ExpertsMap />} />
        
        {/* Routes protégées */}
        <Route
          path={APP_CONFIG.routes.monEspace}
          element={
            <PrivateRoute>
              <UserDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={APP_CONFIG.routes.tickets}
          element={
            <PrivateRoute>
              <TicketDetail />
            </PrivateRoute>
          }
        />

        {/* Pages légales */}
        <Route path={APP_CONFIG.routes.politiqueConfidentialite} element={<PolitiqueConfidentialite />} />
        <Route path={APP_CONFIG.routes.mentionsLegales} element={<MentionsLegales />} />
        <Route path={APP_CONFIG.routes.conditionsUtilisation} element={<ConditionsUtilisation />} />

        {/* Vérification d'email */}
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* Redirection de /dashboard vers /mon-espace */}
        <Route path="/dashboard" element={<Navigate to={APP_CONFIG.routes.monEspace} replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes; 